<template>
  <div
    v-if="template.IOS.Send && template.Android.Send && template.Huawei.Send"
    class="push-preview"
  >
    <button
      @click="slideLeft"
      class="push-preview__btn"
    >
      <img
        src="@/assets/images/templates/arrow.svg"
        alt="arrow"
      >
    </button>
    <div class="push-preview__container">
      <IosPreview
        v-if="active === 0"
        :template="template.IOS"
        class="push-preview__part push-preview__part--ios"
      />
      <AndroidPreview
        v-if="active === 1"
        :template="template.Android"
        class="push-preview__part push-preview__part--android"
      />
      <HuaweiPreview
        v-if="active === 2"
        :template="template.Huawei"
        class="push-preview__part push-preview__part--huawei"
      />
      <div class="push-preview__footer">
        <button
          :class="active === 0 ? 'btn--active' : ''"
          @click="active = 0">
          <IosIcon />
        </button>
        <button
          :class="active === 1 ? 'btn--active' : ''"
          @click="active = 1">
          <AndroidIcon />
        </button>
        <button
          :class="active === 2 ? 'btn--active' : ''"
          @click="active = 2">
          <HuaweiIcon />
        </button>
      </div>
    </div>
    <button
      class="push-preview__btn"
      @click="slideRight"
    >
      <img
        src="@/assets/images/templates/arrow.svg"
        alt="arrow"
      >
    </button>
  </div>
  <div v-else class="node-preview push-preview push-preview--one">
    <IosPreview
      v-if="template.IOS.Send"
      :template="template.IOS"
      class="push-preview__part push-preview__part--ios"
      />
    <AndroidPreview
      v-if="template.Android.Send"
      :template="template.Android"
      class="push-preview__part push-preview__part--android"
    />
    <HuaweiPreview
      v-if="template.Huawei.Send"
      :template="template.Huawei"
      class="push-preview__part push-preview__part--huawei"
    />
  </div>
</template>

<script>
import { scaleHeight } from "@/utils/general";
import IosIcon from "@/components/Icons/IosIcon.vue";
import AndroidIcon from "@/components/Icons/AndroidIcon.vue";
import HuaweiIcon from "@/components/Icons/HuaweiIcon.vue";
import IosPreview from "./IosPreview.vue";
import AndroidPreview from "./AndroidPreview.vue";
import HuaweiPreview from "./HuaweiPreview.vue";

export default {
  name: "PushPreview",
  props: ["template"],
  components: {
    IosIcon,
    AndroidIcon,
    HuaweiIcon,
    IosPreview,
    AndroidPreview,
    HuaweiPreview
  },
  data() {
    return {
      slideArr: ['ios', 'android', 'huawei'],
      active: 0
    }
  },
  mounted() {
    scaleHeight(".template--push", ".push-preview", 255, 648);
  },
  methods: {
    slideLeft() {
      this.active <= 0 ? this.active = this.slideArr.length - 1 : this.active--;
    },
    slideRight() {
       this.active >= this.slideArr.length - 1 ? this.active = 0 : this.active++;
    }
  }
}
</script>

<style lang="scss">
.push-preview {
  max-width: 486px;
  min-width: 386px;
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  transform-origin: 50% 0%;
  &--one {
    justify-content: center;
  }
  &__part {
    height: 618px;
    display: flex;
    align-items: center;

    &--ios {
      background: url("#{$image-path}templates/ios-frame.svg") no-repeat center center;
      background-size: contain;
      width: 306px;
    }
    &--android {
      background: url("#{$image-path}templates/android-frame.svg") no-repeat center center;
      background-size: contain;
      width: 320px;
    }
    &--huawei {
      background: url("#{$image-path}templates/android-frame.svg") no-repeat center center;
      background-size: contain;
      width: 320px;
    }
  }
  &__footer {
    text-align: center;
    .btn--active {
      path {
        fill: #66CC00;
      }
    }
    button {
      background: none;
      padding: 0;
      margin-right: 22px;
      //&:first-of-type {
      //  margin-right: 22px;
      //}
      svg {
        height: 24px;
        width: 20px;
        path {
          transition: fill 0.2s ease-in;
          &:hover {
            fill: rgba(#66CC00, 0.7);
          }
        }
      }
    }
  }

  &__btn {
    background: none;
    padding: 0;
    &:first-of-type {
      transform: rotate(180deg);
    }
    img {
      transition: transform 0.3 ease;
      &:hover,
      &:active,
      &:target {
        transform: scale(1.3);
      }
    }
  }

  .preview-block {
    cursor: pointer;
    width: 100%;
    &__logo {
      display: inline-block;
      color: transparent;
      object-fit: cover;
    }
    &__time {
      font-size: 9px;
      line-height: 13px;
    }
    &__title,
    &__text {
      font-size: 9px;
      line-height: 12px;
      margin: 0;
      overflow-wrap: anywhere;
    }
    &__title {
      color: #000;
      font-weight: bold;
    }
  }
}
</style>
